import { createStore } from "redux";
import rootReducer from "./reducers";
// import { getUserDataFromCookies } from '../utilities/utilities';

const initialStore = {
  // userData: getUserDataFromCookies(),
  userData: null,
  notification: null,
  allNotification: null,
  workspaceSettings: {
    addresses: [],
    // 'noticeForm.purpose.MoneyRecovery.additionalOptions': [],
    // 'noticeForm.purpose.Others.additionalOptions': [],
  },
  agreementflow: null,
};

const store = createStore(rootReducer, initialStore);

export default store;
